import moment from "moment";

class ExpenseReceiptModalController {
  constructor($rootScope, $scope, $uibModalInstance, $interval, $timeout, $http) {
      "ngInject";
      this.name = 'ExpenseReceiptModal';
      $scope.expense = $uibModalInstance.expense;
      $scope.expenseReport = $uibModalInstance.expenseReport;
      $scope.apiHost = $uibModalInstance.apiHost;

      $scope.cancel = $uibModalInstance.cancel;
      $timeout(() => $scope.initModificationPanel());
      this.$http = $http;
      this.$scope = $scope;
      $scope.selectedFile;
      this.$rootScope = $rootScope;

      $scope.initModificationPanel = function (){
        $scope.fileSelector = document.getElementById('file-selector');
        $scope.fileSelector.addEventListener('change', (event) => {
          $scope.selectedFile = $scope.fileSelector.files && $scope.fileSelector.files.length > 0 ? $scope.fileSelector.files[0].name : undefined;
          $rootScope.$apply();
        });
      }


      $scope.addReceipt = function () {
        let receipt = $scope.fileSelector.files[0];

        let config = {
          headers: {
            'Content-Type': undefined
          },
          withCredentials: true,
          transformRequest: angular.identity
        };

        let fd = new FormData();
        fd.append('file', receipt);
        return $http.post($rootScope.apiHost+'/api/expense-reports/'+$scope.expenseReport.id+'/expenses/' + $scope.expense.id + '/receipts', fd, config).then (success => {
        // return $http.post(`${$rootScope.apiHost}/api/expense-reports/${$scope.expense.id}/upload`, fd, config).then (success => {
          $scope.selectedFile = undefined;
          $scope.modificationDate = undefined;
          $uibModalInstance.receiptAdded(success.data);
        }, failure => {
          // this.toastr.error('There was an error uploading the document');
        });
      }

      $scope.cancel = function () {
        $uibModalInstance.cancel();
      }


  }



}

export default ExpenseReceiptModalController;



// WEBPACK FOOTER //
// ./client/pages/expenses/modals/expense-receipt-modal/expense-receipt-modal.controller.js